import type { JSX } from "preact";

/**
 * Animated typing indicator (three bouncing dots)
 */
export const TypingIndicator = (): JSX.Element => (
  <div class="pankagent-typing">
    <span class="pankagent-typing-dot" />
    <span class="pankagent-typing-dot" />
    <span class="pankagent-typing-dot" />
  </div>
);
